export default "dist/images/block-blog-posts-horizontal-card.c6e09ee.png";